export default __webpack_public_path__ + "static/media/linux.9a3d44f2.jpg";